import * as Backbone from 'backbone';
import * as _ from 'underscore';

import config from '../../common/config';

export var Model = Backbone.Model.extend({
    constructor: function () {
        this.defaults = _.extend({}, this.defaults, {
            Calculation: {}
        });

        Backbone.Model.prototype.constructor.apply(this, arguments);
    },
});

export var Collection = Backbone.Collection.extend({
    model:Model,
    constructor: function () {
        Backbone.Collection.prototype.constructor.apply(this, arguments);
    },
    "sync": function (method, model, options) {
        /*window.event4us.event.ad.category01 = '';
        window.event4us.event.ad.category02 = '';
        window.event4us.event.ad.category03 = '';*/

        var category01 = 'a';
        var category02 = 'a';
        var category03 = 'a';

        if (method == 'read') {
            options.url =  config.webApiUrl() + '/api/PublicCustomEventAdBig/-1?Category01=' + category01 + '&Category02=' + category02 + '&Category03=' + category03;
        }
        return Backbone.sync(method, model, options);
    }
});

